module.exports = __webpack_public_path__ + "static/media/result-selected.36108e12.svg";